module.exports = __webpack_public_path__ + "fonts/inter-v2-latin-500.woff?6e76a4cee4838c4ffac07e8b2be5f187";